// Blogs, FAQs, testimonials, centres, cities, team — static content

export const BLOGS = [
  {
    id: 'd1',
    icon: '🩸',
    bg: 'linear-gradient(135deg,#C8EDD8,#8DCFAA)',
    category: 'Diabetes',
    title: 'HbA1c: The 3-Month Window Into Your Blood Sugar',
    excerpt: 'One blood draw, three months of data — and the single most important metabolic marker.',
    author: 'Dr. Anjali Reddy',
    readTime: '8 min',
    date: 'Mar 2026',
  },
  {
    id: 'd2',
    icon: '🔬',
    bg: 'linear-gradient(135deg,#FDF4E3,#F5D799)',
    category: 'Diabetes',
    title: 'Fasting vs Post-Meal Glucose: Which Number Actually Matters More?',
    excerpt: 'Understanding the two most common blood sugar tests and when each applies.',
    author: 'Dr. R. Naidu',
    readTime: '5 min',
    date: 'Feb 2026',
  },
  {
    id: 'c1',
    icon: '❤️',
    bg: 'linear-gradient(135deg,#FEE2E2,#FECACA)',
    category: 'Cardiac',
    title: '5 Blood Tests You Should Get Before Turning 40',
    excerpt: 'Preventive cardiology starts decades before the first symptom.',
    author: 'Dr. S. Mehta',
    readTime: '7 min',
    date: 'Jan 2026',
  },
  {
    id: 'h1',
    icon: '🦋',
    bg: 'linear-gradient(135deg,#EDE9FE,#DDD6FE)',
    category: 'Hormones',
    title: 'Thyroid 101: TSH, T3 and T4 Explained Simply',
    excerpt: 'A TSH-only test misses clinically significant thyroid dysfunction. Here is why.',
    author: 'Dr. P. Sharma',
    readTime: '6 min',
    date: 'Jan 2026',
  },
  {
    id: 'v1',
    icon: '☀️',
    bg: 'linear-gradient(135deg,#D1FAE5,#A7F3D0)',
    category: 'Vitamins',
    title: 'Why 70% of Indians Are Vitamin D Deficient — and What to Do',
    excerpt: 'Deficiency is rampant due to indoor lifestyles and limited sun exposure.',
    author: 'Dr. T. Patel',
    readTime: '6 min',
    date: 'Feb 2026',
  },
  {
    id: 'p1',
    icon: '🧬',
    bg: 'linear-gradient(135deg,#C8EDD8,#A5F3FC)',
    category: 'Preventive Health',
    title: 'The Annual Health Checkup Checklist by Age Group',
    excerpt: 'What to test, and when, across every decade of adult life.',
    author: 'Dr. Anjali Reddy',
    readTime: '9 min',
    date: 'Dec 2025',
  },
];

export const FAQS = [
  ['What is a Trustian?', 'A Trustian is our trained, certified sample collection professional. Every Trustian is background-verified, trained in phlebotomy, and carries sterile single-use equipment.'],
  ['How quickly does the Trustian arrive?', 'Within 60 minutes of booking — guaranteed. Track them live on the app like a food delivery order. If late by a minute, you receive a ₹200 credit.'],
  ['Do I need to fast before my test?', 'Depends on the test. CBC, thyroid and vitamin tests do not require fasting. Blood sugar and lipid profile require 8–12 hours fasting.'],
  ['Is TrustLab NABL accredited?', 'Yes. TrustLab\'s central laboratory is NABL accredited under ISO 15189:2022 — the global gold standard for medical lab quality.'],
  ['How will I receive my reports?', 'Doctor-verified reports are sent to your WhatsApp and email and stored permanently in the TrustLab app. Share via secure link with any doctor.'],
  ['Can I reschedule or cancel?', 'Yes. Up to 2 hours before your slot via WhatsApp or app. No cancellation fee.'],
  ['Is home collection more expensive?', 'No. Home collection is included at the same price as walk-in for all tests. No surcharge.'],
  ['What cities does TrustLab serve?', 'Hyderabad, Bengaluru, Mumbai, Delhi, Gurugram and Noida. Expanding to Pune, Chennai and Kolkata in 2026.'],
  ['Can I book for a family member?', 'Yes. Add their details during checkout. Manage multiple family members from one account.'],
  ['How do I share my report with my doctor?', 'Tap Share in the app and send a secure link. No login required for your doctor.'],
];

export const TESTIMONIALS = [
  {
    avatar: 'PK',
    color: '#3D7A52',
    name: 'Priya Kaur',
    meta: 'Banjara Hills · Full Body',
    text: 'Trustian was at my door before I had my morning tea. Report on WhatsApp by 2 PM with clear Vitamin D flagging. This is what healthcare should feel like — fast, accurate, human.',
  },
  {
    avatar: 'RS',
    color: '#12B981',
    name: 'Rohit Sharma',
    meta: 'Koramangala · HbA1c + Thyroid',
    text: 'Tracked my Trustian on the app like a Swiggy order — 48 minutes exactly. The report explained every abnormal value clearly. My endocrinologist said it was one of the best-formatted reports she had seen.',
  },
  {
    avatar: 'AM',
    color: '#C97D08',
    name: 'Ananya Mehta',
    meta: 'Gurugram · TrustLab Member',
    text: 'TrustLab is my go-to for monthly monitoring now. Reports in hours, the trend graphs are genuinely useful, and my doctor loves the data I bring. Best health decision I have made this year.',
  },
  {
    avatar: 'SV',
    color: '#8B5CF6',
    name: 'Suresh Varma',
    meta: 'Hyderabad · Diabetes Package',
    text: 'The diabetes care package is incredibly thorough. Everything from HbA1c to insulin levels to kidney function in one visit. Reports in 5 hours with clear risk flags.',
  },
  {
    avatar: 'NP',
    color: '#DC2626',
    name: 'Neha Patel',
    meta: 'Mumbai · Women\'s Wellness',
    text: 'Booking took 2 minutes, Trustian arrived in 45 minutes, report in 6 hours. I have used every major lab in Mumbai — TrustLab is a completely different class of experience.',
  },
];

export const CENTRES = [
  { id: 1, name: 'Banjara Hills', addr: 'Plot 45, Road 12', city: 'Hyderabad', hours: '7 AM – 9 PM', phone: '040-7440-0754' },
  { id: 2, name: 'Kondapur', addr: 'Cyber Gateway, Hitech City', city: 'Hyderabad', hours: '7 AM – 9 PM', phone: '040-7440-0755' },
  { id: 3, name: 'Madhapur', addr: 'Laxmi Cyber City', city: 'Hyderabad', hours: '7 AM – 9 PM', phone: '040-7440-0756' },
  { id: 4, name: 'Koramangala', addr: '80 Feet Rd, 4th Block', city: 'Bangalore', hours: '6 AM – 10 PM', phone: '080-7440-0754' },
  { id: 5, name: 'Indiranagar', addr: '100 Feet Rd', city: 'Bangalore', hours: '6 AM – 10 PM', phone: '080-7440-0755' },
  { id: 6, name: 'Gurugram Sec 15', addr: 'Prem Tower, Sector 15', city: 'Gurugram', hours: '6 AM – 10 PM', phone: '0124-744-0075' },
];

export const CITIES = [
  { code: 'hyd', name: 'Hyderabad', badge: 'HQ · 2 centres', landmark: 'NRL Begumpet · NRL Dilsukhnagar' },
  { code: 'blr', name: 'Bengaluru', badge: '1 centre', landmark: 'Koramangala' },
  { code: 'noi', name: 'Noida', badge: '1 centre', landmark: 'Sector 18 · Sector 62' },
  { code: 'viz', name: 'Visakhapatnam', badge: '1 centre', landmark: 'Dwaraka Nagar · MVP Colony' },
  { code: 'vjw', name: 'Vijayawada', badge: '1 centre', landmark: 'Kanaka Durga Nagar' },
  { code: 'gnt', name: 'Guntur', badge: '1 centre', landmark: 'Brodipet · Arundelpet' },
  { code: 'jmu', name: 'Jammu', badge: '1 centre', landmark: 'Gandhi Nagar · Trikuta Nagar' },
  { code: 'chd', name: 'Chandigarh', badge: '1 centre', landmark: 'Sector 22 · Sector 35' },
];

export const MEMBERSHIP_PLANS = [
  {
    tier: 'Saver',
    price: 999,
    tagline: 'One-time joining fee',
    perks: [
      'Free On-call Doctor Consultation',
      '4 Free HbA1c tests (quarterly)',
      'Priority customer support',
      'Online health reports access',
      'Health trend tracking',
    ],
    featured: false,
  },
  {
    tier: 'Premium',
    price: 1999,
    tagline: 'One-time joining fee',
    perks: [
      'Everything in Saver',
      '₹1,000 worth of free tests',
      'AI health trend analysis',
      'Priority Trustian scheduling',
      'Family health locker (4 members)',
      'Doctor consultation for all packages',
    ],
    featured: true,
  },
  {
    tier: 'Corporate',
    price: null,
    tagline: 'Per employee · Min 10',
    perks: [
      'Custom package design',
      'HR analytics dashboard',
      'Bulk pricing (10+ employees)',
      'Employee self-booking portal',
      'Anonymised group health insights',
      'Dedicated account manager',
    ],
    featured: false,
  },
];

export const TEAM = [
  { initials: 'DM', color: '#152A1E', name: 'Dhruv Mehta', role: 'Co-Founder & CEO', bio: 'Ex-Practo · IIT Bombay · Built TrustLab from 0 to 1M patients. 12 years in health-tech.' },
  { initials: 'TB', color: '#C97D08', name: 'Tarun Bhat', role: 'Co-Founder & COO', bio: 'Ex-McKinsey · ISB · Designed the Trustian program and cold chain logistics.' },
  { initials: 'AR', color: '#3D7A52', name: 'Dr. Akhil Rao', role: 'Chief Pathologist', bio: '22 years · AIIMS Delhi · Oversees clinical accuracy and pathologist training.' },
  { initials: 'RI', color: '#12B981', name: 'Dr. Ramesh Iyer', role: 'Medical Director', bio: '20 years · CMC Vellore · Leads the in-house medical advisory board.' },
  { initials: 'PM', color: '#6366F1', name: 'Priya Mohan', role: 'Chief Technology Officer', bio: 'Ex-Flipkart · BITS Pilani · Built the app, GPS tracking and AI analytics.' },
  { initials: 'SP', color: '#EC4899', name: 'Siddharth Patel', role: 'VP — Operations', bio: 'Ex-Ola · IIM Ahmedabad · Manages Trustian network across 13 cities.' },
  { initials: 'NK', color: '#0EA5E9', name: 'Dr. Nalini Kumar', role: 'Head — QA', bio: 'NABL auditor · 16 years · Leads lab quality protocols and accreditation compliance.' },
  { initials: 'RV', color: '#F59E0B', name: 'Rohan Varma', role: 'VP — Growth & Marketing', bio: 'Ex-PharmEasy · ISB · Leads patient acquisition, brand and city expansion.' },
];

export const USER_TYPES = [
  { id: 'individual', icon: '👤', name: 'Individual', desc: 'Personal health reports & test bookings for you and your family' },
  { id: 'corporate', icon: '🏢', name: 'Corporate', desc: 'Employee health programmes, bulk testing & HR analytics dashboard' },
  { id: 'medical', icon: '🩺', name: 'Medical Professional', desc: 'Doctors, pathologists & clinics — access patient reports & referral portal' },
  { id: 'lab', icon: '🔬', name: 'Lab Partners', desc: 'Collection centres, franchise labs & partner diagnostic facilities' },
  { id: 'qa', icon: '🛡️', name: 'TrustLab QA', desc: 'Quality assurance — complaint management, client reports & analytics' },
];
